import React, {memo, useState, useEffect, useCallback} from 'react';
import {setExplorePersonSelected} from 'actions/index.js';
import WorkMetadata from "components/explore/mix2/WorkMetadata.js";
import {getWallpapers} from 'decentralized/settings/appearance.js';
import {useComments} from '../comments/useComments.js';
import WorkList from './WorkList.js';
import {connect} from 'react-redux';
import {setProjectDragging} from 'actions/index.js';
import {getBlockDate} from 'utils/getBlockDate.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import WorkSamples from './WorkSamples.js';
import WorkMix from './WorkMix.js';
import {SEQUENCE, SAMPLES, MIX, LIST} from './types.js';
import ethereum from 'decentralized/ethereum.js';
import {getWorkGraphic} from './getWorkGraphic.js';
import {formatDate} from 'components/selector2/formatDate.js';

const Work = memo(({
    work,
    onClick,
    loadSample,
    onClickMix,
    onClickList,
    setSearchTag,
    setProjectDragging,
    setPersonSelected
}) => {
    const [graphic, setGraphic] = useState('');
    const [title, setTitle] = useState(work.title);
    const [loading, setLoading] = useState(false);
    const [collaborators, setCollaborators] = useState([]);
    const [date, setDate] = useState(undefined);
    const [thumbnail, setThumbnail] = useState(undefined);
    const [works, setWorks] = useState([work]);
    work.id = work.newSequence

    useEffect(() => {
        if (work.guildId) {
            ethereum.guildSequences._decryptQueryResult(work)
                .then(s => setTitle(s.title));
        }
    }, [work, setTitle]);

    const {comments} = useComments({works});

    useEffect(() => {
        if (work.type === SEQUENCE) {
            getWorkGraphic(work).then(
                async ({wallpaper, graphic, bpm}) => {
                    setGraphic(graphic);
               });
        }
    }, [work]); 

    useEffect(() => {
        getBlockDate(work.blockNumber).then(
            setDate);
    }, [work, setDate]);

    useEffect(() => {
        if (work.collaborators) {
            let promises = [];
            for (let c of work.collaborators) {
                promises.push(ethereum.users.getUserName(c));
            }
            Promise.all(promises).then(
                setCollaborators);
        }
    }, [work, setCollaborators]);

    if (work.type === MIX) {
        return (
            <WorkMix work={work} onClick={onClickMix}> </WorkMix>
        );
    } else if (work.type === LIST) {
        return (
            <WorkList onClick={onClickList} work={work}/>
        );
    }

    let isEdit = work.previousSequence && work.previousSequence !== '';

    let style = {};
    if (thumbnail) {
        style.backgroundImage = 'url(/ipfs/' + thumbnail + ')';
    }

    let hours = undefined;
    let minutes = undefined;
    if (date) {
        let now = new Date();
        let timeSince = now.getTime() - date.getTime();
        minutes = Math.ceil(timeSince / 1000 / 60);
        hours = Math.ceil(minutes / 60);
    }

    return (
        <div
          draggable={true}
          onDragStart={() => setProjectDragging(work)}
          onDragOver={(e) => e.preventDefault()}
          onClick={() => onClick(work)}
          className="work">
          <WorkMetadata
            setSearchTag={setSearchTag}
            editTags={false}
            showComments={true}
            work={work}/>
          <div
            className="graphic">
            {graphic}
          </div>
          <div
            className="name">
            <div
              className="work-author">
              {collaborators.map(
                  (x, i) =>
                      <div
                        onClick={(e) => {
                            e.stopPropagation();
                            setPersonSelected(work.collaborators[i]);
                        }}
                        className={i === 0 ? "collaborator origin" : "collaborator"}>{x}</div>)}
            </div>
            <div style={style} className="work-thumb"></div>
            <div className="work-title">
              <span>{title}</span>
            </div>
          </div>
          <div className="work-edit-info">
            {isEdit ? 'Edit' : 'Original'}
          </div>
          <div  className="work-date">
            {date ?
             minutes < 60 ? minutes + " min ago" :
             hours < 48 ? hours + " hours ago" :
             formatDate(date) : ''}
          </div>
        </div>
    );
});

const mapDispatchToProps = (dispatch) => {
  return {
      setProjectDragging: (x) => dispatch(setProjectDragging(x)),
      setPersonSelected : id => dispatch(setExplorePersonSelected(id))
  };
};

export default connect(null, mapDispatchToProps)(Work);
